import type { StackProps } from '@chakra-ui/react';
import { GasFee } from '@ui/components/SwapDialog/GasFee';
import { Token, useNormalTokenConfig } from '@ui/config/token';
import { GAS_TOKEN } from '@ui/config/token/tokenConfig';
import { useBondingCurveTradingGasFee } from '@ui/hooks/bondingCurve/useBondingCurveTradingGasFee';
import { useTokenPrice } from '@ui/hooks/tokenPrice';
import { useGlobalChainLayer } from '@ui/hooks/useGlobalChainLayer';

import { useBondingTradeDialog } from '../useBondingTradeDialog';
import { useBondingTradeForm } from './BondingTradeForm/useBondingTradeForm';

export const BondingTradeGasFee = (props: StackProps) => {
  const fromToken = useBondingTradeForm((s) => s.fromToken);
  const isSell = fromToken === Token.Bonding;
  const enteredAmount = useBondingTradeForm((s) => s.enteredAmount);
  const bondingTokenAddress = useBondingTradeDialog(
    (s) => s.bondingTokenAddress,
  );
  const chainLayer = useGlobalChainLayer();

  const gasTokenInfo = useNormalTokenConfig()[GAS_TOKEN[chainLayer]];

  const gasPrice = useTokenPrice({
    token: GAS_TOKEN[chainLayer],
  }).data?.usd_price;
  const { data, isFetching } = useBondingCurveTradingGasFee({
    fromAmount: enteredAmount,
    bondingTokenAddress,
    type: isSell ? 'sell' : 'buy',
  });

  return (
    <GasFee
      data={data}
      gasTokenInfo={gasTokenInfo}
      gasPrice={gasPrice}
      isFetching={isFetching}
      {...props}
    />
  );
};
